import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';
import { questionValidation } from '../../functions/Validation';
import './address.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMagnifyingGlass, faHouse, faSpinner, faHouseCircleExclamation } from '@fortawesome/free-solid-svg-icons'
import { useOutsideClick } from '../../functions/OutsideClick';
import ValidationMessage from '../question/ValidationMessage';
import { tracking } from '../../functions/Tracking';
import { Action } from '../../enums/TrackingActionType';
import { useNavigate, useLocation } from "react-router-dom";
import { getErrorLogIdFromResponse } from '../../functions/ErrorLogging';
import QuestionHelp from '../question/QuestionHelp';

export default function PostcodeRepeatableChild(props: any) {
    const [question, setQuestion] = useState(props.question);
    const [textValue, setTextValue] = useState(question.answer);
    const [foundAddresses, setFoundAddresses] = useState<any[]>([]);
    const [searching, setSearching] = useState(false);
    const [noResults, setNoResults] = useState(false);
    const [secondsFocused, setSecondsFocused] = useState(0);
    const timerId = useRef<number>(0);
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

    let navigate = useNavigate();

    const handleClickOutside = () => {
        setNoResults(false);
    };

    const ref = useOutsideClick(handleClickOutside);

    var inputClasses = classNames(
        {
            'postcode-input': true,
            'validation-fail': question.validationFail,
            'short-form-question': question.page === 0
        }
    );

    var labelClasses = classNames(
        {
            'validation-fail-lbl': question.validationFail
        }
    );

    let placeholderText = props.question.placeholder ? props.question.placeholder : "Postcode";

    useEffect(() => {
        setQuestion(props.question);
        if (props.question.answer) {
            setTextValue(props.question.answer);
        }

        document.addEventListener("updateAnswerAtIndex", function (e) {
            let eventDetails: any = e;
            if (eventDetails.detail.questionID === question.questionSetQuestion.questionID && eventDetails.detail.index == question.index) {
                setTextValue(eventDetails.detail.answer);
                question.validationFail = false;
                setQuestion(question);
            }
        });
    }, []);

    useEffect(() => {
        if (secondsFocused === 60) {
            //alert("Too much time has passed");
            //alert(question.questionSetQuestion.text);
        }
    }, [secondsFocused]);

    useEffect(() => {
        question.answer = textValue;
    }, [textValue]);

    const startTimer = () => {
        timerId.current = window.setInterval(() => {
            setSecondsFocused(prev => prev + 1);
        }, 1000)
    }

    const stopTimer = () => {
        window.clearInterval(timerId.current);
        setSecondsFocused(0);
    }

    const updateAnswer = (e: React.ChangeEvent<HTMLInputElement>) => {
        setTextValue(e.target.value);
        setFoundAddresses([]);
        setNoResults(false);
    }

    const validateAnswer = () => {
        stopTimer();
        tracking(Action.SAVE_QUESTIONS, question.questionSetQuestion.questionID);
        question.validationFail = !questionValidation(question);

        setQuestion(question);
    }

    const searchPostcode = (postcode: string) => {
        setSearching(true);
        if (postcode !== "" && postcode !== null && postcode !== undefined) {
            fetch(`${apiBaseUrl}customer/searchpostcode/${postcode}`)
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    setSearching(false);
                    if (data.object !== "") {
                        let foundAddresses = JSON.parse(data.object);
                        setFoundAddresses(foundAddresses);
                    } else {
                        setNoResults(true);
                    }
                }).catch((error) => {
                    let errorLogId = getErrorLogIdFromResponse(error);
                    localStorage.setItem("errorLogId", errorLogId);
                    navigate('/Error');
                    setSearching(false);
                    setNoResults(true);
                });
        } else {
            setSearching(false);
            setNoResults(true);
        }
    }

    const selectAddress = (index: number) => {
        let selectedAddress = foundAddresses[index];
        delete selectedAddress.extensionData;
        question.validationFail = false;
        setQuestion(question);
        props.setChildResponseAddress(foundAddresses[index], props.questionIdPosition);
        props.setRPOPropertyAddress(foundAddresses[index]);
        setFoundAddresses([]);
    }

    return (
        <>
            <div className="question">
                <label className={labelClasses} htmlFor={"valen_" + question.questionSetQuestion.questionID}>{question.questionSetQuestion.text}</label>
                <br />
                    <div className="search-container">
                        <div className="search-inner">
                            <input
                                type="text"
                                value={textValue}
                                id={"valen_" + question.questionSetQuestion.questionID}
                                className={inputClasses}
                                onChange={(e) => updateAnswer(e)}
                                onFocus={() => startTimer()}
                                onBlur={() => validateAnswer()}
                                onKeyUp={(event) => {
                                    if (event.key === "Enter") {
                                        searchPostcode(textValue);
                                    }
                                }}
                                
                            />
                            {!searching && <button className="btn-address icon" onClick={() => searchPostcode(textValue)}><FontAwesomeIcon icon={faMagnifyingGlass} /></button>}
                            {searching && <button className="btn-address icon searching"><FontAwesomeIcon icon={faSpinner} spinPulse /></button>}
                        {question.questionSetQuestion.helpText !== null && question.questionSetQuestion.helpText !== "" &&
                            <QuestionHelp helpText={question.questionSetQuestion.helpText} questionID={question.questionSetQuestion.questionID} />
                        }
                        </div>
                        <div className="dropdown">
                            {noResults && <div ref={ref} className="dropdown-row no-results"><FontAwesomeIcon className="error-icon" icon={faHouseCircleExclamation} /> No addresses found</div>}
                            {foundAddresses.map((address, index) => (
                                <div className="dropdown-row" key={index} onClick={() => selectAddress(index)}>{address.house + ", " + address.street + ", " + address.locality + ", " + address.city + ", " + address.postcode}</div>
                            ))}
                        </div>
                    </div>

                <div>
                </div>
                
                {question.validationFail &&
                    <ValidationMessage question={question} overrideMessage="Please enter a valid postcode." />}
                
            </div>
        </>
    );
}